import { ModalWrapper } from 'components';
import { BlockProps } from './tableBlocks/types';
import ConfirmModal from 'components/Modals/ConfirmModal';
import { useBuyNowMutation } from 'services/api/alternative-offers';
import { modalsHide, snackShow } from 'actions';
import { useDispatch } from 'react-redux';
import { formatCurrency } from 'utils';

export const BuyNowModal = ({ currentVehicle }: BlockProps) => {
  const modalName = `buyNowModal-${currentVehicle.id}`;

  const [buyNowMutation] = useBuyNowMutation();

  const dispatch = useDispatch();

  const buyNow = async () => {
    const response = await buyNowMutation(currentVehicle.id);
    if ('error' in response) {
      dispatch(snackShow({ type: 'error', message: 'Failed to buy vehicle' }));
    } else {
      dispatch(snackShow({ message: 'Successfully bought vehicle' }));
    }
    dispatch(modalsHide(modalName))
  };

  if (!currentVehicle.active_alternative_offer) {
    return null;
  }

  return (
    <ConfirmModal
      modalId={modalName}
      submitText={'Buy'}
      handleSubmit={buyNow}
      title={`You are about to buy ${currentVehicle.year} ${currentVehicle.model} ${currentVehicle.make} for ${formatCurrency(currentVehicle.active_alternative_offer.amount)} `}
    />
  );
};
